export const wpClassNames = {
    WRAPPER: 'resources-tile-block',
    BUTTON_ICON: 'ql-herocta-svg-icon',
    BLUSH: 'blush',
}